import {
  FETCHING_DEFERRED_ROLLFORWARD_REPORT,
  FETCHING_DEFERRED_ROLLFORWARD_REPORT_SUCCESS,
  FETCHING_DEFERRED_ROLLFORWARD_REPORT_FAILURE,
  FETCHING_DEFERRED_ROLLFORWARD_REPORT_DATA_FOR_ALL_PILLS,
  FETCHING_DEFERRED_ROLLFORWARD_REPORT_DATA_FOR_ALL_PILLS_SUCCESS,
  FETCHING_DEFERRED_ROLLFORWARD_REPORT_DATA_FOR_ALL_PILLS_FAILURE,
  CHANGE_AGGREGATION_DROPLIST_VALUE,
  UPDATE_EDITED_CELL,
  REVERT_EDITED_CELLS,
} from './types';
import initialState from './initialState';
import { mapAffectedTotalsToStateUpdates, updateTotalValue } from '../../gridReport/storeHelpers';

const updateEditedRow = (
  rows,
  { description, key, value, affectedTotals, extraValues = {} }
) => rows.map(row => {
  if (row.DESCRIPTION.toLowerCase() === 'total') {
    const rowWithEditedValue = rows.find(
      r => r.DESCRIPTION === description
    );
    const previousCellValue = rowWithEditedValue[key].value;
    const totalUpdates = mapAffectedTotalsToStateUpdates(affectedTotals, row, previousCellValue, value);

    return {
      ...row,
      [key]: updateTotalValue(row, previousCellValue, value, key),
      ...totalUpdates,
    };
  }

  if (row.DESCRIPTION !== description) {
    return row;
  }

  const previousCellValue = row[key].value;
  const totalUpdates = mapAffectedTotalsToStateUpdates(affectedTotals, row, previousCellValue, value);

  return {
    ...row,
    [key]: {
      ...row[key],
      ...extraValues,
      value,
      edited: true,
      unapprovedFlag: true,
    },
    ...totalUpdates,
  };
});

const deferredRollforwardReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCHING_DEFERRED_ROLLFORWARD_REPORT:
      return {
        ...state,
        originalReportRows: null,
        reportData: initialState.reportData,
        isFetchingReportData: true,
      };
    case FETCHING_DEFERRED_ROLLFORWARD_REPORT_SUCCESS:
      return {
        ...state,
        originalReportRows: null,
        reportData: payload.reportData,
        isFetchingReportData: false,
      };
    case FETCHING_DEFERRED_ROLLFORWARD_REPORT_FAILURE:
      return {
        ...state,
        originalReportRows: null,
        reportData: initialState.reportData,
        isFetchingReportData: false,
      };
    case FETCHING_DEFERRED_ROLLFORWARD_REPORT_DATA_FOR_ALL_PILLS:
      return {
        ...state,
        isExportingReport: true,
      };
    case FETCHING_DEFERRED_ROLLFORWARD_REPORT_DATA_FOR_ALL_PILLS_SUCCESS:
    case FETCHING_DEFERRED_ROLLFORWARD_REPORT_DATA_FOR_ALL_PILLS_FAILURE:
      return {
        ...state,
        isExportingReport: false,
      };
    case CHANGE_AGGREGATION_DROPLIST_VALUE:
      return {
        ...state,
        aggregationDroplistValue: payload.value,
      };
    case UPDATE_EDITED_CELL: {
      const originalReportRows = !state.originalReportRows
        ? { originalReportRows: [...state.reportData.rows] }
        : {};

      return {
        ...state,
        ...originalReportRows,
        reportData: {
          ...state.reportData,
          rows: updateEditedRow(state.reportData.rows, payload),
        },
      };
    }
    case REVERT_EDITED_CELLS:
      return {
        ...state,
        reportData: {
          ...state.reportData,
          rows: [
            ...state.originalReportRows,
          ],
        },
      };
    default:
      return state;
  }
};

export default deferredRollforwardReducer;
